import store from '@/store'
import ok from '@/utils/ok.js'
import api from '@/api/file/index.js'

var md5 = require('md5');

export default {
  async upload(ref,file, pieceSize, call) {
    var extName = file.name.split(".")[file.name.split(".").length - 1];
    const chunkSize = pieceSize * 1024 * 1024;// 1MB一片
    const chunkCount = Math.ceil(file.size / chunkSize); // 总片数
   var _fileKey = file.lastModified + "_" + file.size + "_" +file.type + "_"+ chunkCount;
    this._calculateMd5(this._getChunkInfo(file, 0, chunkSize).chunk,res => {
      _fileKey = _fileKey+"_"+res;
      this._calculateMd5(this._getChunkInfo(file, chunkCount-1, chunkSize).chunk,res => {
        _fileKey = _fileKey+"_"+res;
        const fileMd5 = md5(_fileKey);
        this._upload_start(ref,file,extName,chunkSize,chunkCount,fileMd5,call)
      });
    });
  },

  _upload_start(ref,file,extName,chunkSize,chunkCount,fileMd5,call){
    var pra = {uuid: fileMd5, sliceNum: chunkCount, size: file.size, extName: extName};
    api.file_update_start(pra).then(res => {
      if (!res.complete) {
        this._file_update_slice(ref,file, res.requireUploads, chunkSize, fileMd5, chunkCount, 0, call);
      } else {
        call("OK", 100, res);
      }
    });
  },


  _file_update_slice(ref,file, requireUploads, chunkSize, fileMd5, chunkCount, index, call) {
    if (!ref.ok_file_update_status)return;
    if (requireUploads.length <= 0) {
      this._file_update_complete(fileMd5,call);
      return;
    }
    if (index >= requireUploads.length) {
      this._file_update_complete(fileMd5,call);
      return;
    }

    var _file_index = requireUploads[index];
    var fileChunk = this._getChunkInfo(file, _file_index, chunkSize);

    // var file_data = {
    //   sequence: _file_index,
    //   uuid: md5(fileMd5 + "_" + _file_index),
    //   uploadUuid: fileMd5,
    //   file: fileChunk.chunk
    // };

    const file_data = new FormData();
    file_data.append('sequence', _file_index);
    file_data.append('uuid', md5(fileMd5 + "_" + _file_index));
    file_data.append('uploadUuid', fileMd5);
    file_data.append('multipartFile', fileChunk.chunk);

    var process = parseInt(((index + (chunkCount - requireUploads.length)) / chunkCount) * 100);
    api.file_update_slice(file_data).then(res => {
        this._file_update_slice(ref,file, requireUploads, chunkSize, fileMd5, chunkCount, index + 1, call);
        call("UPDATE", process)
      },
      err => {
        this._file_update_slice(ref,file, requireUploads, chunkSize, fileMd5, chunkCount, index, call);
        call("UPDATE", process)
      });
  },
  _file_update_complete(uuid, call) {
    api.file_update_complete({uuid}).then(res => {
        console.log(res);
        call("OK", 100, res);
      },
      err => {
        console.log(err);
        call("ERROR", 100, err);
      });
  },

  /***
   * 获取每一个分片的详情
   **/
  _getChunkInfo(file, currentChunk, chunkSize) {
    let start = currentChunk * chunkSize
    let end = Math.min(file.size, start + chunkSize)
    let chunk = file.slice(start, end)
    return {
      start,
      end,
      chunk
    }
  },
  _calculateMd5(blob, callback) {
    var reader = new FileReader();
    reader.readAsBinaryString(blob);
    reader.onloadend = function () {
      var  hash = md5(reader.result);
      callback(hash);
    };
  }
}
